export function getSigninUrl(redirectPath: string): string {
  return `${window.location.origin}/login?redirectPath=${encodeURIComponent(redirectPath)}`;
}
